var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section"},[_c('div',{class:_vm.centered && 'd-flex align-center justify-center',staticStyle:{"min-height":"100vh"}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }